import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	TEmAutomationAssignedScriptsResponsePayload,
	TEmAutomationAvailableScriptsResponsePayload,
	TEmAutomationScriptsStore,
} from './types';

const getEmAutomationScriptsState = (state: TStoreState): TEmAutomationScriptsStore =>
	state.emAutomationScripts;

export const getAvailableScripts = createSelector(
	[getEmAutomationScriptsState],
	(s: TEmAutomationScriptsStore): TEmAutomationAvailableScriptsResponsePayload =>
		s.availableScripts,
);

export const getAvailableScriptsLoading = createSelector(
	[getEmAutomationScriptsState],
	(s: TEmAutomationScriptsStore): boolean => s.availableScriptsLoading,
);

export const getAssignedScripts = createSelector(
	[getEmAutomationScriptsState],
	(s: TEmAutomationScriptsStore): TEmAutomationAssignedScriptsResponsePayload => s.assignedScripts,
);

export const getAssignedScriptsLoading = createSelector(
	[getEmAutomationScriptsState],
	(s: TEmAutomationScriptsStore): boolean => s.assignedScriptsLoading,
);

export const getAssignScriptLoading = createSelector(
	[getEmAutomationScriptsState],
	(s: TEmAutomationScriptsStore): boolean => s.assignScriptLoading,
);

export const getAssignScriptSuccess = createSelector(
	[getEmAutomationScriptsState],
	(s: TEmAutomationScriptsStore): boolean => s.assignScriptSuccess,
);

export const getRemoveScriptLoading = createSelector(
	[getEmAutomationScriptsState],
	(s: TEmAutomationScriptsStore): boolean => s.removeScriptLoading,
);

export const getRemoveScriptSuccess = createSelector(
	[getEmAutomationScriptsState],
	(s: TEmAutomationScriptsStore): boolean => s.removeScriptSuccess,
);
